import { render } from "./dutyTypeCard.vue?vue&type=template&id=06b5404f&scoped=true"
import script from "./dutyTypeCard.vue?vue&type=script&lang=js"
export * from "./dutyTypeCard.vue?vue&type=script&lang=js"

import "./dutyTypeCard.vue?vue&type=style&index=0&id=06b5404f&lang=scss&scoped=true"

import exportComponent from "D:\\project\\admin-system3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06b5404f"]])

export default __exports__